import { JMDevTools } from 'components/Elements';
import { AppProvider } from 'providers/app';
import { AppRoutes } from 'routes';

import 'sweetalert2/src/sweetalert2.scss';

function App() {
  return (
    <AppProvider>
      {/* {process.env.NODE_ENV === 'development' && <JMDevTools />} */}
      <AppRoutes />
    </AppProvider>
  );
}

export default App;
